import { dew as _createClientDew } from "./createClient.js";
import { dew as _walletDew } from "./decorators/wallet.js";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.createWalletClient = void 0;
  const createClient_js_1 = _createClientDew();
  const wallet_js_1 = _walletDew();
  function createWalletClient(parameters) {
    const {
      key = "wallet",
      name = "Wallet Client",
      transport
    } = parameters;
    const client = (0, createClient_js_1.createClient)({
      ...parameters,
      key,
      name,
      transport: opts => transport({
        ...opts,
        retryCount: 0
      }),
      type: "walletClient"
    });
    return client.extend(wallet_js_1.walletActions);
  }
  exports.createWalletClient = createWalletClient;
  //# sourceMappingURL=createWalletClient.js.map
  return exports;
}